var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',{staticStyle:{"padding":"0"},attrs:{"height":"114.78px"}},[_c('Header',{attrs:{"teleNum":_vm.teleNum}})],1),_c('el-container',[_c('el-aside',[_c('Leftnav',{attrs:{"menuList":_vm.menu}})],1),_c('el-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }